import React from 'react';
import { useLazyQuery } from '@apollo/client';
import GET_SUBMITTED_FEEDBACK_DATA from '../queries/getSubmittedFeedbacksDataQuery';
import { LocalFilesService } from '../../shared/services/localFilesService';

const DownloadFeedbackReport = () => {
  const [getSubmittedFeedback] = useLazyQuery(GET_SUBMITTED_FEEDBACK_DATA);

  const downloadFeedbackReport = async e => {
    e.preventDefault();
    const { data } = await getSubmittedFeedback();

    if (!data) {
      return;
    }

    const feedbackData = data.submittedFeedbacks.map(feedback => ({
      'Date submitted': feedback.SubmittedDate,
      'Name of submitter': feedback.SubmitterName,
      'Email of submitter': feedback.SubmitterEmail,
      'Role of submitter': feedback.SubmitterRole,
      Comment: feedback.Comment
    }));

    await LocalFilesService.saveCsvFileAsZip(fileName, feedbackData);
  };

  return (
    <a href='#' className='level-0-menu navigation-menu__label' onClick={downloadFeedbackReport}>
      View Feedback
    </a>
  );
};

const fileName = 'VIP Portal Feedback';

export default DownloadFeedbackReport;
